<template>
    <div class="componentTab table">
        <table>
        <tr v-for="value in values" :key="value.label">
            <td>{{ value.label }}</td>
            <td class="value">{{ numberSpacing(value.value) }}</td>
        </tr>
        <tr class="total" :class="{'no-border': index+1 == totals.length}" v-for="(total,index) in totals" :key="total.label">
            <td>{{ total.label }}</td>
            <td class="value">{{ numberSpacing(total.value) }}</td>
        </tr>
        </table>
    </div>
</template>

<script>
    export default {
        props: {
            values: Array,
            totals: Array
        },

        methods: {
            numberSpacing(number) {
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
             
            }
        },
    }
</script>

